import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function CartPage() {
  const { items, updateQuantity, removeFromCart, totalPrice } = useCart();

  if (items.length === 0) {
    return (
      <div className="page-header">
        <span className="badge">Your Cart</span>
        <h1>Cart is empty</h1>
        <p>Nothing in here yet — go find something worth printing.</p>
        <Link to="/products" className="customize-button" style={{ display: 'inline-block', marginTop: 20 }}>
          [ BROWSE_PRODUCTS ]
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="page-header">
        <span className="badge">Your Cart</span>
        <h1>Cart</h1>
      </div>

      <div className="cart-page">
        <div className="cart-items">
          {items.map((item) => (
            <div key={item.id} className="cart-item hud-frame">
              <img src={item.image} alt={item.name} className="cart-item-img" />
              <div className="cart-item-info">
                <span className="unit-tag-inline">UNIT_{String(item.id).padStart(3, '0')}</span>
                <h4>{item.name}</h4>
                <p className="cart-item-price">Rs{item.price}.00</p>
              </div>
              <div className="cart-item-qty">
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
              </div>
              <p className="cart-item-subtotal">Rs{(item.price * item.quantity).toFixed(2)}</p>
              <button className="cart-remove" onClick={() => removeFromCart(item.id)}>✕</button>
            </div>
          ))}
        </div>

        <div className="cart-summary hud-frame">
          <h3>Order Summary</h3>
          <div className="summary-row">
            <span>Subtotal</span>
            <span>Rs{totalPrice.toFixed(2)}</span>
          </div>
          <div className="summary-row total">
            <span>Total</span>
            <span>Rs{totalPrice.toFixed(2)}</span>
          </div>
          <button className="auth-submit">[ CHECKOUT ]</button>
        </div>
      </div>
    </>
  );
}